module.exports = __webpack_public_path__ + "static/media/feature-example-A.b93476c2.png";